import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeedFilters = ({ onFilterChange, activeFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const filterOptions = [
    { id: 'all', label: 'All Posts', icon: 'Grid3X3' },
    { id: 'donations', label: 'Donations', icon: 'Heart' },
    { id: 'stories', label: 'Impact Stories', icon: 'BookOpen' },
    { id: 'challenges', label: 'Challenges', icon: 'Trophy' },
    { id: 'following', label: 'Following', icon: 'Users' }
  ];

  const sortOptions = [
    { id: 'recent', label: 'Most Recent', icon: 'Clock' },
    { id: 'popular', label: 'Most Popular', icon: 'TrendingUp' },
    { id: 'impact', label: 'Highest Impact', icon: 'Target' }
  ];

  const handleFilterClick = (filterId) => {
    onFilterChange('type', filterId);
  };

  const handleSortClick = (sortId) => {
    onFilterChange('sort', sortId);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Mobile Filter Toggle */}
      <div className="md:hidden">
        <Button
          variant="ghost"
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full justify-between"
        >
          <span>Filters & Sort</span>
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
        </Button>
      </div>
      {/* Filter Content */}
      <div className={`${isExpanded ? 'block' : 'hidden'} md:block ${isExpanded ? 'mt-4' : ''}`}>
        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-2 mb-4">
          {filterOptions?.map((filter) => (
            <Button
              key={filter?.id}
              variant={activeFilters?.type === filter?.id ? "default" : "outline"}
              size="sm"
              onClick={() => handleFilterClick(filter?.id)}
              iconName={filter?.icon}
              iconPosition="left"
              className="flex-shrink-0"
            >
              {filter?.label}
            </Button>
          ))}
        </div>

        {/* Sort Options */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />
            <span className="text-sm font-medium text-card-foreground">Sort by:</span>
          </div>
          
          <div className="flex space-x-2">
            {sortOptions?.map((sort) => (
              <Button
                key={sort?.id}
                variant={activeFilters?.sort === sort?.id ? "default" : "ghost"}
                size="sm"
                onClick={() => handleSortClick(sort?.id)}
                iconName={sort?.icon}
                iconPosition="left"
              >
                <span className="hidden sm:inline">{sort?.label}</span>
                <span className="sm:hidden">
                  <Icon name={sort?.icon} size={16} />
                </span>
              </Button>
            ))}
          </div>
        </div>

        {/* Active Filters Summary */}
        {(activeFilters?.type !== 'all' || activeFilters?.sort !== 'recent') && (
          <div className="mt-3 pt-3 border-t border-border">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="text-sm text-muted-foreground">Active filters:</span>
                <div className="flex space-x-1">
                  {activeFilters?.type !== 'all' && (
                    <span className="inline-block px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
                      {filterOptions?.find(f => f?.id === activeFilters?.type)?.label}
                    </span>
                  )}
                  {activeFilters?.sort !== 'recent' && (
                    <span className="inline-block px-2 py-1 bg-secondary/10 text-secondary text-xs rounded-full">
                      {sortOptions?.find(s => s?.id === activeFilters?.sort)?.label}
                    </span>
                  )}
                </div>
              </div>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onFilterChange('reset')}
                className="text-muted-foreground hover:text-foreground"
              >
                Clear All
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedFilters;